export const HOME = "/";
export const ABOUT = "/sobre-nosotros";
export const AUTHOR_DETAIL = "/equipo/:username";
export const ARTICLE_DETAIL = "/articulo/:slug";
export const SEARCH = "/articulos";
export const RESOURCES = "/recursos";
